import {
  REQUEST_MY_BOOKINGS,
  RECEIVE_MY_BOOKINGS,
  REQUEST_MY_BOOKING_DETAILS,
  RECEIVE_MY_BOOKING_DETAILS,
  REQUEST_MY_BOOKING_COMPANIONS,
  RECEIVE_MY_BOOKING_COMPANIONS,
  UPDATE_MY_BOOKING_COMPANIONS,
  COMPLETE_UPDATE_MY_BOOKING_COMPANIONS
} from '../constants/actionTypes';

import { receiveErrorResponse } from './api';

import { completeSignOut } from './auth';

import { Auth } from 'aws-amplify';

import api, { apiAuth } from '../api';
import { fakeMyBookingsApi2 } from '../constants/fakeMyBookings';
import { fakeMyBookingDetailsApi2 } from '../constants/fakeMyBookingDetails';
import { fakeMyCompanionsApi } from '../constants/fakeMyCompanions';

const unauthorizedError = {
  response: {
    status: 403
  }
};

export const requestMyBookings = () => ({
  type: REQUEST_MY_BOOKINGS
});

export const receiveMyBookings = bookings => ({
  type: RECEIVE_MY_BOOKINGS,
  bookings
});

export const requestMyBookingDetails = () => ({
  type: REQUEST_MY_BOOKING_DETAILS
});

export const receiveMyBookingDetails = bookingDetails => ({
  type: RECEIVE_MY_BOOKING_DETAILS,
  bookingDetails
});

export const requestMyBookingCompanions = () => ({
  type: REQUEST_MY_BOOKING_COMPANIONS
});

export const receiveMyBookingCompanions = companions => ({
  type: RECEIVE_MY_BOOKING_COMPANIONS,
  companions
});

export const updateMyBookingCompanions = () => ({
  type: UPDATE_MY_BOOKING_COMPANIONS
});

export const completeUpdateMyBookingCompanions = data => ({
  type: COMPLETE_UPDATE_MY_BOOKING_COMPANIONS,
  message: data.message
});

// For live
export function fetchMyBookings() {
  return function(dispatch) {
    dispatch(requestMyBookings());
    return apiAuth('/v1/my-booking')
      .then(response => {
        dispatch(receiveMyBookings(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
        if (err === 'No current user') {
          dispatch(completeSignOut());
        }
      });
  };
}

// For live
export function fetchMyBookingDetails(uuid) {
  return function(dispatch) {
    dispatch(requestMyBookingDetails());
    return apiAuth(`/v1/my-booking/detail?booking_uuid=${uuid}`)
      .then(response => {
        dispatch(receiveMyBookingDetails(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
        if (err === 'No current user') {
          dispatch(completeSignOut());
        }
      });
  };
}

export function fetchMyBookingCompanions(uuid) {
  return function(dispatch) {
    dispatch(requestMyBookingCompanions());
    return apiAuth(`/v1/my-booking/detail/edit-companion?booking_uuid=${uuid}`)
      .then(response => {
        dispatch(receiveMyBookingCompanions(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
        if (err === 'No current user') {
          dispatch(completeSignOut());
        }
      });
  };
}

export function doUpdateMyBookingCompanions(uuid, formData, xcsrfToken) {
  return function(dispatch) {
    dispatch(updateMyBookingCompanions());
    return apiAuth(
      `/v1/my-booking/detail/update-companion?booking_uuid=${uuid}`,
      'patch',
      xcsrfToken,
      formData
    )
      .then(response => {
        dispatch(completeUpdateMyBookingCompanions(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
        if (err === 'No current user') {
          dispatch(completeSignOut());
        }
      });
  };
}

// For test
// export function fetchMyBookings() {
//   return function(dispatch) {
//     dispatch(requestMyBookings());
//     return new Promise((resolve, reject) => {
//       setTimeout(resolve, 500);
//     }).then(() => dispatch(receiveMyBookings(fakeMyBookingsApi2)));
//   };
// }

// For test
// export function fetchMyBookingDetails() {
//   return function(dispatch) {
//     dispatch(requestMyBookings());
//     return new Promise((resolve, reject) => {
//       setTimeout(resolve, 500);
//     }).then(() => dispatch(receiveMyBookingDetails(fakeMyBookingDetailsApi2)));
//   };
// }

// export function fetchMyBookingCompanions(uuid) {
//     return function(dispatch) {
//         dispatch(requestMyBookingCompanions());
//         return new Promise((resolve, reject) => {
//             setTimeout(resolve, 500);
//         }).then(() => dispatch(receiveMyBookingCompanions(fakeMyCompanionsApi)));
//     };
// }
